@if (lineItems$ | async; as lineItems) {
<div class="custom-mini-cart-main-container">
  <div class="custom-product-rows-block">
    @if (basketError$ | async; as basketError) {
    <ish-basket-error-message [error]="basketError" />
    }
    <ish-basket-validation-results />
    @for (lineItem of lineItems | slice : 0 : maxItemNumber; track lineItem) {
    <div class="custom-product-row">
      <ng-container ishProductContext [sku]="lineItem.productSKU">
        <div class="custom-mini-product-img">
          <ish-product-image imageType="S" [link]="true" />
        </div>
        <div class="custom-mini-product-info">
          <ish-product-name />
          <div class="custom-mini-cart-icons">
            <a class="custom-mini-cart-cog">
              <custom-edit-line-item [pli]="lineItem" [icon]="['fas', 'cog']" />
            </a>
            @if (!lineItem.isFreeGift) {
            <custom-mini-cart-remove-item-confirmation-modal (confirm)="onDeleteItem(lineItem.id)" [options]="options">
              <p>{{ 'mini_cart.remove_item.confirmation.modal.content' | translate }}</p>
            </custom-mini-cart-remove-item-confirmation-modal>
            }
          </div>
          <div class="custom-cart-pli-data">
            <span>{{ 'shopping_cart.pli.qty.label' | translate }}</span> {{ lineItem.quantity.value }}
          </div>
          <div class="custom-product-price">{{ lineItem.price | ishPrice }}</div>
        </div>
      </ng-container>
    </div>
    } @if (maxItemNumber && lineItems.length >= maxItemNumber + 1) {
    <div class="alert alert-info mb-0" data-testing-id="show-all-cart-items-hint">
      {{ 'shopping_cart.ministatus.show_all_items.text' | translate }}
    </div>
    }
  </div>
  <div class="custom-mini-cart-bottom-section">
    <div class="custom-mini-cart-subtotal">
      <span class="custom-mini-cart-label">Cart Subtotal: </span>
      @if (itemTotal$ | async; as itemTotal) {
      <span class="custom-mini-cart-price">{{ itemTotal | ishPrice }}</span>
      }
    </div>
    <button class="btn btn-lg btn-block btn-primary" routerLink="/basket">
      {{ 'shopping_cart.ministatus.view_cart.link' | translate }}
    </button>
    <button
      *ishHasNotRole="['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER']"
      type="submit"
      class="btn btn-lg btn-block btn-primary"
      (click)="minicheckout()"
    >
      {{ 'shopping_cart.proceed_to_checkout.button.label' | translate }}
    </button>
  </div>
</div>
} @else { @if (basketError$ | async; as basketError) {
<ish-basket-error-message [error]="basketError" cssClass="text-danger" />
}
<div class="custom-mini-cart-empty">
  <i class="icon-shopping-bag"></i>
  <span>{{ 'shopping_cart.ministatus.empty_cart.text' | translate }}</span>
</div>
}
